import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { RoleModel } from './model/role.model';
import { UserModel } from './model/user.model';

@Injectable()
export class AuthBackend {
  private API_ROOT = environment.apiUrl;

  private HEADERS = new HttpHeaders({
    // 'content-type': 'application/json',
    //  'enctype': 'multipart/form-data',
    // 'Auth-Token':
    //   '27563e389c45cfba3d586e9e1b785f6934a919a81aaf5619cb43b22ab58eddcb',
  });

  constructor(private http: HttpClient) {}

  fetchUpdateRoles(roles: RoleModel[]): Observable<HttpResponse<any>> {
    const url = `${this.API_ROOT}/auth/role`;
    return this.http.post<any[]>(url, { roles }, this.getOptions());
  }

  fetchUpdateUser(user: UserModel): Observable<HttpResponse<any>> {
    const url = `${this.API_ROOT}/users`;
    return this.http.post<any[]>(url, { user }, this.getOptions());
  }

  fetchLogin(userCredentials: {
    username: string;
    password: string;
  }): Observable<HttpResponse<any>> {
    const url = `${this.API_ROOT}/auth/login`;
    return this.http.post<any[]>(url, { userCredentials }, this.getOptions());
  }

  fetchAuthUser(userId: string): Observable<HttpResponse<any>> {
    const url = `${this.API_ROOT}/auth/authenticated-user`;
    return this.http.post<any[]>(url, { userId }, this.getOptions());
  }

  fetchUsers(): Observable<HttpResponse<any>> {
    const url = `${this.API_ROOT}/users`;
    return this.http.get<any[]>(url, this.getOptions());
  }

  fetchRoles(): Observable<HttpResponse<any>> {
    const url = `${this.API_ROOT}/auth/role`;
    return this.http.get<any[]>(url, this.getOptions());
  }

  private getOptions(): {
    headers: HttpHeaders;
    observe: 'response';
    params:
      | HttpParams
      | {
          [param: string]: string | string[];
        };
  } {
    return {
      headers: this.HEADERS,
      observe: 'response',
      params: {
        t: `${Date.now()}`,
      },
    };
  }
}
